
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/london/seo-design-portfolio/wordpress-seo-agency",
      function () {
        return require("private-next-pages/london/seo-design-portfolio/wordpress-seo-agency/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/london/seo-design-portfolio/wordpress-seo-agency"])
      });
    }
  